import(/* webpackMode: "eager" */ "/app/src/app/apps/page.tsx");
